import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Repeat, Loader2, ExternalLink } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "../ui/table";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function formatData(d) {
  if (!d) return "—";
  const [y, m, day] = d.split("-");
  return `${day}/${m}/${y}`;
}

export default function CostiRicorrentiSection({ fascicoloId, token }) {
  const [ricorrenze, setRicorrenze] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!fascicoloId || !token) return;
    setLoading(true);
    axios
      .get(`${API_URL}/api/prima-nota/ricorrenze`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { ospiteId: fascicoloId },
      })
      .then((res) => setRicorrenze(res.data.ricorrenze || []))
      .catch(() => setRicorrenze([]))
      .finally(() => setLoading(false));
  }, [fascicoloId, token]);

  return (
    <Card className="card-base shadow-sm">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg flex items-center gap-2">
          <Repeat className="w-5 h-5 text-emerald-600" />
          Costi ricorrenti
        </CardTitle>
        <Button variant="outline" size="sm" asChild>
          <Link to={`/prima-nota-ospiti?tab=ricorrenze&ospite=${fascicoloId}`}>
            <ExternalLink className="w-4 h-4 mr-1" />
            Gestisci in Prima Nota
          </Link>
        </Button>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex justify-center py-8">
            <Loader2 className="w-6 h-6 animate-spin text-emerald-600" />
          </div>
        ) : ricorrenze.length === 0 ? (
          <p className="text-sm text-slate-500 py-4">Nessuna ricorrenza configurata per questo ospite.</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Voce</TableHead>
                <TableHead className="text-right">Importo</TableHead>
                <TableHead>Frequenza</TableHead>
                <TableHead>Prossima generazione</TableHead>
                <TableHead>Stato</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {ricorrenze.map((r) => (
                <TableRow key={r.id}>
                  <TableCell className="font-medium">{r.descrizione}</TableCell>
                  <TableCell className="text-right">€ {Number(r.importo || 0).toFixed(2)}</TableCell>
                  <TableCell className="capitalize">{r.frequenza}</TableCell>
                  <TableCell>{formatData(r.prossimaGenerazione)}</TableCell>
                  <TableCell>
                    <Badge variant="outline" className={
                      r.stato === "attiva" ? "border-emerald-200 text-emerald-700" : "border-slate-200"
                    }>
                      {r.stato}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
